import ProgrammeImage3 from "../../../../../assets/images/png/courses/international/programme3.webp";
import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const cloudComputingSchoolDataEurope = {
  tag: "Cloud",
  id: "cloudSchool",
  url: "/cloud-school",
  image: SchoolImage,

  name: "Cloud School",
  description: `
  The Utiva Cloud Developers Program is designed to train you for the skills in 
  demand by top and leading companies. Now you can pursue Careers and specialized 
  roles such as Cloud Administrator, cloud security engineers and cloud architect. 
  `,
  keywords: `cloud computing, cloud school, cloud computing certification`,
  metatags: `Utiva is the best place to learn cloud computing in Nigeria. We train you and help you become Microsoft certified in cloud computing.`,

  courses: [
    {
      id: 2,
      courseImage: ProgrammeImage3,
      courseName: "Cloud Bootcamp",
      courseDescription: `
      This training is designed by top professionals to help you learn the 
      latest skills of the Cloud Developer using Microsoft Azure program, 
      you will learn how to deploy, build, migrate, 
      and monitor applications on Azure.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "16 Weeks",

      courseTags: ["For Early Starters"],

      courseUrl: "/cloud-bootcamp",

      enrolUrl: "https://learn.utiva.io/enroll/2063594?price_id=2792248",

      bookCallUrl: "https://calendar.app.google/4CH6CdurjV6h22oW9",
      chatWithUsUrl: "https://wa.me/447951258903",
    },
  ],
  testimony: {
    // testimonierImage: TestimonialImage,
    testimonierName: "Ope Oyenowo",
    testimonierTitle: "Cloud Engineer",
    testimonyDescription: `I was not exactly sure what I will get at the 
    end of the day but I trusted this because Utiva had a very known name. 
    I enrolled in the 4 month learning program and I can tell you that it 
    was worth my time. I moved to Dublin before the training 
    was completed and got a new job in Dublin. Very exciting journey. `,
  },

  article: [],

  careerTitle: "Cloud Specialist",

  careerPaths: [
    "Cloud Architect",
    "Cloud Security Analyst",
    "Cloud Computing Specialist",
    "Cloud Administrator",
    "Cloud Automation Engineer",
  ],

  quickFactSalary: "$120,000 ",

  quickFacts: [
    "Cloud Computing has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum, citing it as the next wave of information technology for individuals, companies and governments.",
  ],
};
